import { rankHot } from "@/mocks/chigua";

const quickChips = [
  { name: "娱乐八卦", href: "#map", icon: "ri-star-smile-line" },
  { name: "影视综艺", href: "#map", icon: "ri-movie-2-line" },
  { name: "科技数码", href: "#map", icon: "ri-rocket-2-line" },
  { name: "电竞体娱", href: "#map", icon: "ri-gamepad-line" },
  { name: "城市生活", href: "#map", icon: "ri-cup-line" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-gradient-to-b from-primary-50 via-background-50 to-background-50">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/60 blur-3xl" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -left-16 top-40 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl" aria-hidden="true"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-10 pt-28 md:px-6 md:pt-36">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs text-primary-700">
              <i className="ri-water-flash-line" aria-hidden="true"></i>
              全网瓜田 · 导航首页
            </span>
            <h1 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-5xl md:leading-tight">
              今天吃什么瓜？<br className="hidden sm:block" />
              一张图带你<span className="text-primary-500">按图索骥</span>
            </h1>
            <p className="mt-5 max-w-xl text-base text-foreground-600 md:text-lg">
              吃瓜入口网聚合各平台热门爆料入口，吃瓜入口地图标注所有活跃板块，吃瓜入口索引收录最新事件——把全网瓜田收拾成一本好翻的导航大全，想围观哪块地，直接点进去。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a href="#ranking" className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 transition-all hover:-translate-y-0.5 hover:bg-primary-600">
                <i className="ri-fire-line" aria-hidden="true"></i>
                查看今日热瓜榜
              </a>
              <a href="#map" className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-6 py-3 text-sm text-foreground-800 transition-all hover:-translate-y-0.5 hover:border-primary-300 hover:text-primary-600">
                <i className="ri-road-map-line" aria-hidden="true"></i>
                打开吃瓜地图
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-2">
              <span className="whitespace-nowrap text-xs text-foreground-500">快速入口</span>
              {quickChips.map((c) => (
                <a key={c.name} href={c.href} className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 transition-colors hover:bg-secondary-200">
                  <i className={c.icon} aria-hidden="true"></i>
                  {c.name}
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-2xl border border-background-200/70 bg-background-50 p-5 shadow-soft">
              <div className="flex items-center justify-between">
                <h2 className="font-heading text-lg text-foreground-950">此刻最热</h2>
                <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-100 px-2.5 py-1 text-xs text-primary-700">
                  <i className="ri-radio-button-line animate-pulse" aria-hidden="true"></i>
                  实时热度
                </span>
              </div>
              <ul className="mt-4 flex flex-col gap-1">
                {rankHot.slice(0, 5).map((item) => (
                  <li key={item.rank}>
                    <a href="#ranking" className="flex items-center gap-3 rounded-lg px-2 py-2.5 transition-colors hover:bg-primary-50">
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${item.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"}`}>
                        {item.rank}
                      </span>
                      <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">{item.title}</span>
                      <span className="hidden shrink-0 whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900 sm:inline-block">{item.tag}</span>
                    </a>
                  </li>
                ))}
              </ul>
              <a href="#ranking" className="mt-3 flex items-center justify-center gap-1 whitespace-nowrap rounded-lg py-2 text-sm text-primary-600 transition-colors hover:bg-primary-50 hover:text-primary-700">
                展开完整热搜总榜
                <i className="ri-arrow-down-s-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}